/* LUNA sliding disclosure — D250 (Liv, 09-12).

   Liv: "remember how you made the drop down feature on product pages like a
   scroll, with a click it doesn't immediately appear but it slides down? Apply
   this feature to all the other drop downs, like the FAQ sections."

   That behaviour is D185, and it lived inside luna-pdp.js where only the PDP
   accordions could use it. This is the same motion, lifted out and made
   generic, so any disclosure in the theme gets it by adding one attribute:

       <details data-luna-slide> <summary>…</summary> <div>…</div> </details>

   The panel is whatever element follows the <summary>.

   FIVE THINGS THAT MATTER, each of which is a bug if you get it wrong:

   1. THE MARKUP STAYS <details>. It is not replaced with divs and ARIA. With
      JavaScript off, or if this file fails to load, the disclosure still opens,
      still works on a keyboard, and still reads correctly to a screen reader.
      It simply snaps instead of sliding. Motion is the enhancement; the control
      is native.

   2. `open` MUST SURVIVE THE CLOSING ANIMATION. A <details> hides its content
      the instant `open` is removed, so removing it up front would make the
      panel vanish and leave an empty box animating to nothing. It is removed on
      transitionend, at the end.

   3. HEIGHT CANNOT TRANSITION TO auto. The open target is measured by flipping
      the panel to height:auto with transitions off, reading the box, then
      putting it back. Once open it returns to auto, or a later reflow (a web
      font landing, an image loading, someone resizing) would be clipped by a
      stale pixel value.

   4. BOTTOM SPACE RIDES ON THE LAST CHILD, NOT ON THE PANEL'S PADDING. This is
      the D185 lesson and it is easy to lose. Everything is border-box, so a
      padding-bottom on a height:0 box cannot be squeezed out: the used height
      floors at the padding and every closed row shows a sliver. A margin has
      no such floor, and overflow:hidden keeps it inside the measured height.
      The section CSS is written that way; do not move it back to padding.

   5. REDUCED MOTION IS NOT ENHANCED AT ALL. Rather than animating faster, a
      visitor who asks for less motion simply gets the native <details>, which
      is the honest answer and has no edge cases.

   Does NOT change which panels can be open at once. The FAQ allows several;
   the PDP is exclusive. That is a separate decision from how they move. */
(function(){
  if(window.__lunaAcc) return; window.__lunaAcc = true;

  var EASE = 'height .34s cubic-bezier(.4,0,.2,1)';

  function reduced(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panelOf(d){
    var el = d.querySelector('summary');
    return el ? el.nextElementSibling : null;
  }

  /* measure the open height without the user seeing the flip */
  function naturalHeight(p){
    var h0 = p.style.height, t0 = p.style.transition;
    p.style.transition = 'none';
    p.style.height = 'auto';
    var h = p.getBoundingClientRect().height;
    p.style.height = h0;
    void p.offsetHeight;
    p.style.transition = t0;
    return h;
  }

  function init(d){
    if(d.__lunaAcc) return;
    var p = panelOf(d);
    if(!p) return;
    d.__lunaAcc = true;

    d.classList.add('is-slide');
    p.style.transition = EASE;
    p.style.overflow = 'hidden';
    p.style.height = d.open ? 'auto' : '0px';

    var busy = false, closing = false;

    p.addEventListener('transitionend', function(e){
      if(e.propertyName !== 'height' || e.target !== p) return;
      busy = false;
      if(closing){
        closing = false;
        d.removeAttribute('open');
        p.style.height = '0px';
      } else {
        p.style.height = 'auto';
      }
    });

    d.querySelector('summary').addEventListener('click', function(e){
      /* summary fires click for Enter and Space too, so keyboard keeps working */
      e.preventDefault();
      if(busy) return;

      if(!d.open){
        d.open = true;               /* in flow before it can be measured */
        p.style.height = '0px';
        void p.offsetHeight;
        busy = true; closing = false;
        p.style.height = naturalHeight(p) + 'px';
      } else {
        p.style.height = p.getBoundingClientRect().height + 'px';
        void p.offsetHeight;
        busy = true; closing = true;
        p.style.height = '0px';      /* `open` comes off at transitionend */
      }
    });
  }

  function scan(){
    if(reduced()) return;
    var list = document.querySelectorAll('details[data-luna-slide]');
    for(var i = 0; i < list.length; i++) init(list[i]);
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', scan); }
  else { scan(); }
  document.addEventListener('shopify:section:load', scan);
})();